import {ChangeDetectionStrategy, Component, HostListener, Input} from '@angular/core';
import {Router} from '@angular/router';

import {SimpleWord} from '../../models/simple-word.model';
import {multiLinkMixin} from '../../mixins/multi-link.mixin';
import {DynamicComponentService} from '../../services/dynamic-component/dynamic-component.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';

@Component({
  selector: 'li[app-word-disp-list-item]',
  templateUrl: './word-disp-list-item.component.html',
  styleUrls: ['./word-disp-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WordDispListItemComponent extends multiLinkMixin {
  @Input() word: SimpleWord;
  @Input() openPopup = false;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  @HostListener('click', ['$event'])
  public onClick($event: MouseEvent): void {
    if (!this.openPopup) {
      return;
    }

    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.word?.id) {
      this.OpenMultiLink(this.word.id).subscribe({
        next: resultLinkPopup => {
          console.log('WordDispListItemComponent.onClick() resultLinkPopup =', resultLinkPopup);
        },
        error: err => {
          console.error('WordDispListItemComponent.onClick() error =', err);
        },
      });
    }
  }
}
